import styled from "styled-components";
import { MainContainer, TextMessage, TextPrimary } from "../../components";
import { TermsText } from "../TermsOfUse/styles";
import { Colors, Styleguide } from "../../theme";

export const OfferPage = styled(MainContainer)`
  min-height: 100vh;
  width: 100%;
  box-sizing: border-box;
  background: ${Colors.gray[500]};
  color: ${Colors.white};
  font-family: ${Styleguide.fonts.body.name};
  gap: 0;
`;

export const OfferContent = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: min(100%, 588px);
  min-height: 100vh;
  margin: 0 auto;
  padding: 28px 24px 24px;
  text-align: center;

  > svg {
    width: 180px;
    height: auto;
    margin-bottom: 92px;
  }

  > img {
    border-radius: 48px;
    margin-bottom: 56px;
  }

  @media (min-width: ${Styleguide.breakpoints.tablet}) {
    padding: 40px 40px 32px;

    > svg {
      margin-bottom: 104px;
    }

    > img {
      margin-bottom: 64px;
    }
  }
`;

export const OfferHeading = styled(TextPrimary)`
  font-size: ${Styleguide.fontSizes[24]};
  font-weight: ${Styleguide.fontWeights.semibold};
  line-height: 100%;
  letter-spacing: 0;
  max-width: 520px;
  margin: 0;
`;

export const OfferDescription = styled(TextMessage)`
  font-family: Inter, sans-serif;
  font-size: ${Styleguide.fontSizes[18]};
  line-height: 150%;
  letter-spacing: 0;
  max-width: 520px;
  margin: 40px 0 0;
  color: ${Colors.gray[200]};
  text-align: center;

  strong {
    color: ${Colors.white};
    font-weight: ${Styleguide.fontWeights.bold};
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 496px;
  margin-top: auto;
`;

export const OfferTerms = styled(TermsText)`
  display: block;
  margin: 24px 0 20px;
`;

export const OfferUnavailable = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  padding: 32px 24px;
  text-align: center;

  > svg {
    width: 180px;
    height: auto;
    margin-bottom: 64px;
  }
`;

export const OfferUnavailableText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 480px;

  > h1 {
    margin: 0;
  }

  > p {
    margin: 24px 0;
    color: ${Colors.gray[200]};
    text-align: center;
  }

  > a {
    max-width: 312px;
    text-decoration: none;

    @media (min-width: ${Styleguide.breakpoints.tablet}) {
      max-width: 360px;
    }
  }
`;
